import AxiosInterceptorLogger from "./axios-interceptor-logger";
import DatabaseStore from "./database-store";

class AxiosInterceptorDatabaseLogger extends AxiosInterceptorLogger {
    private _db: DatabaseStore;

    constructor(databaseName: string, version: number, storeName: string) {
        super(undefined);
        this._db = new DatabaseStore(databaseName, version, storeName);
    }

    log(o: any) {
        this._db.add(o);
    }

    clear() {
        this._db.clear();
    }

    getLogs(callback: any) {
        this._db.get(callback);
    }
}

export default AxiosInterceptorDatabaseLogger;
